// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__hG_Mf","content":"styles_content__2LzML","selectAll":"styles_selectAll__3jaze"};